// extracted by mini-css-extract-plugin
module.exports = {"icon":"NavLinks_icon__1nA5Y","nav-links":"NavLinks_nav-links__1h6rJ","active":"NavLinks_active__3Xwgn"};